// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__227ar","label":"Category_label__VKnNB","content":"Category_content__3a-Of","header":"Category_header__3H9eY","location":"Category_location__1axTr"};